import React, { useRef, useEffect, useState, CSSProperties } from 'react'

interface IframeProps {
  id?: string
  'data-cy'?: string
  linkHref: string
  className?: string
  allowFullScreen?: boolean
  allow?: string
  width?: number
  height?: number
  title?: string
  frameBorder?: string
  style?: CSSProperties
}

const Iframe = ({ linkHref, className, width, height, style, ...props }: IframeProps) => {
  const ref = useRef<HTMLIFrameElement>()
  const [iframeHeight, setIframeHeight] = useState<number>(0)
  useEffect(() => {
    ref?.current?.addEventListener('load', () =>
      setIframeHeight(
        !height && width ? Math.floor((width * 9) / 16) : Math.floor((ref?.current?.offsetWidth * 9) / 16),
      ),
    )
  }, [ref.current])

  return (
    <iframe
      ref={ref}
      src={linkHref}
      width={width ? width : '100%'}
      height={height ? height : iframeHeight}
      style={{ maxWidth: '100%', ...(style || '') }}
      className={className || ``}
      loading="lazy"
      {...props}
    />
  )
}

export default Iframe
